var getAssetDataFromTheme = function getAssetDataFromTheme(assetId, themeContainer, currentTheme) {
  var _currentThemeStorage$;
  var defaultStorage = themeContainer.default;
  var currentThemeStorage = themeContainer[currentTheme];
  return (_currentThemeStorage$ = currentThemeStorage === null || currentThemeStorage === void 0 ? void 0 : currentThemeStorage[assetId]) !== null && _currentThemeStorage$ !== void 0 ? _currentThemeStorage$ : defaultStorage[assetId];
};

export { getAssetDataFromTheme };
//# sourceMappingURL=getAssetDataFromTheme.js.map
